import type { User } from "@domaddress/shared";
import ContactsPage from "./ContactsPage";

export default function PersoneelPage({ user }: { user: User | null }) {
  return (
    <ContactsPage
      user={user}
      apiPath="/api/personeel"
      title="Personeel"
      singularLabel="personeelslid"
      pluralLabel="personeelsleden"
      importPath="/personeel/importeren"
      pageKey="personeel"
    />
  );
}
